export interface IRunningTaskModel  {
    prefix?:string;
    id: string;
    title?: string;
    percentage?: number;
    type?: string;
}

export class RunningTaskModel implements IRunningTaskModel  {
    prefix?:string;
    id: string;
    title?: string;
    percentage?: number;
    type?: string;
    
    constructor(option?: any) {
        this.prefix = option.prefix || "running-task";
        this.id = option.id || `${this.prefix}-${new Date().getTime()}`;
        this.title = option.title || "";
        this.percentage = option.percentage || 0;
        this.type = option.type || "info";
    }
}
